<template>
	<div class="margin-left-sm">
		<!-- 登录信息 -->
		<div class="bg-white  myinfo flex flex-direction justify-between">
			<div class="flex align-center padding-sm" v-if="user">
				<img class="block-74 margin-right-xs" :src="user.avatar" >
				<div>
					<div class="flex">
						<p class="name">{{user.nick_name}}</p>
						<p class="identity text-xs text-theme">{{userInfo.type | filterType}}</p>
					</div>
					<p class="name text-left margin-top-xs text-999">{{user.phone}}</p>
				</div>
			</div>
			<div class="flex align-center justify-between realname">
				<div class="flex align-center">
					<img src="../../assets/img/pre_icon.png" >
					<p class="text-theme text-xs margin-left-xs">您的简历名片被查看了 {{seeUserinfo}} 次</p>
				</div>
				<div class="flex align-center" @click="godetail('setplacement')">
					<img src="../../assets/img/you_icon.png" >
					<p class="text-theme text-xs text-bold margin-left-xs pointer">去置顶</p>
				</div>
			</div>
		</div>
		<!-- 登录信息 end -->
		<div class="bg-white basic margin-top-sm">
			<div class="flex align-center justify-between solid-bottom padding-sm">
				<p class="name">基本信息</p>
				<div class="flex align-center pointer" @click="godetail('basic')">
					<img class="czuo" src="https://manage.ciiply.com/web/static/my/czuo.png" >
					<p class="text-theme">去编辑</p>
				</div>
			</div>
			<div class="padding-sm">
				<div class="flex align-center margin-bottom-sm" v-if="user">
					<div class="flex align-center flex-sub">
						<p class="titlan text-left text-ccc">姓名</p>
						<p class="text-666">{{user.nick_name}}</p>
					</div>
					<div class="flex align-center flex-sub">
						<p class="titlan text-left text-ccc">电话</p>
						<p class="text-666">{{user.phone}}</p>
					</div>
				</div>
				<div class="flex align-center margin-bottom-sm" v-if="user">
					<div class="flex align-center flex-sub">
						<p class="titlan text-left text-ccc">性别</p>
						<p class="text-666">{{user.sex==1?'男':user.sex==2?'女':'保密'}}</p>
					</div>
					<div class="flex align-center flex-sub">
						<p class="titlan text-left text-ccc">民族</p>
						<p class="text-666">{{user.nation}}</p>
					</div>
				</div>
				<div class="flex align-center margin-bottom-sm" v-if="userInfo">
					<div class="flex align-center flex-sub" v-if="userInfo.category&&userInfo.category.length!=0">
						<p class="titlan text-left text-ccc">工种类别</p>
						<p class="text-666 text-left flex-sub">
							<span v-for="(item,index) in userInfo.category" :key="index">{{item.work_categroy_name}}</span> 
							<span v-if="index < userInfo.category.length-1">,</span>
						</p>
					</div>
					<div class="flex align-center flex-sub">
						<p class="titlan text-left text-ccc">身份选择</p>
						<p class="text-666">{{userInfo.type | filterType}}</p>
					</div>
				</div>
				<div class="flex align-center margin-bottom-sm" v-if="userInfo">
					<div class="flex align-center flex-sub" v-if="userInfo.settlement">
						<p class="titlan text-left text-ccc">期望结算</p>
						<p class="text-666">{{userInfo.settlement}}</p>
					</div>
					<div class="flex align-center flex-sub" v-if="userInfo.wages">
						<p class="titlan text-left text-ccc">期望薪资</p>
						<p class="text-666">{{userInfo.wages == 0?'面议':userInfo.wages}}</p>
					</div>
				</div>
				<div class="flex align-center margin-bottom-sm" v-if="userInfo&&userInfo.area">
					<p class="titlan text-left text-ccc">期望区域</p>
					<p class="text-666  text-left flex-sub">{{userInfo.area}}</p>
				</div>
				<div class="flex align-center margin-bottom-sm" v-if="userInfo&&userInfo.content">
					<p class="titlan text-left text-ccc">求职详情</p>
					<p class="text-666  text-left flex-sub">{{userInfo.content}}</p>
				</div>
				<div class="flex align-center margin-bottom-sm" v-if="userInfo&&userInfo.evaluate">
					<p class="titlan text-left text-ccc">自我评价</p>
					<p class="text-666  text-left flex-sub">{{userInfo.evaluate}}</p>
				</div>
				<div class="flex" v-if="userInfo&&userInfo.images&&userInfo.images.length!=0">
					<p class="titlan text-left text-ccc">个人风采</p>
					<div>
						<img v-for="(item,index) in userInfo.images" :key="index" class="block-90" :src="item" >
					</div>
				</div>
			</div>
		</div>
		<div class="basic bg-white margin-top-sm">
			<div class="flex align-center justify-between solid-bottom padding-sm">
				<p class="name">项目经历</p>
				<div class="flex align-center pointer" @click="addpro">
					<img class="czuo" src="https://manage.ciiply.com/web/static/my/czuo.png" >
					<p>去添加</p>
				</div>
			</div>
			<div class="padding-sm" v-for="(item,index) in experience" :key="index">
				<div class="flex align-center justify-between">
					<p class="text-bold text-333 text-df">{{item.work_name}}</p>
					<div class="flex align-center pointer" @click="editpro(item)">
						<img src="../../assets/img/edit_p.png" >
						<p class="text-xs text-333">修改</p>
					</div>
				</div>
				<p class="text-ccc text-df text-left margin-tb-sm">{{item.end_time}} 完工      {{item.area}}</p>
				<p class="text-666 text-df text-left margin-bottom-sm">{{item.work_content}}</p>
				<div class="flex" v-if="item.images">
					<img v-for="(ele,indaex) in item.images" :key="indaex" class="block-103" :src="ele" >
				</div>
			</div>
		</div>
		<div class="basic bg-white margin-top-sm">
			<div class="flex align-center justify-between solid-bottom padding-sm">
				<p class="name">技能证书</p>
				<div class="flex align-center pointer" @click="addcerti">
					<img class="czuo" src="https://manage.ciiply.com/web/static/my/czuo.png" >
					<p>去添加</p>
				</div>
			</div>
			<div class="" v-if="certificate.length != 0">
				<div class="flex align-center justify-between padding-sm solid-bottom" v-for="(item,index) in certificate" :key="index">
					<div class="flex align-center">
						<p class="text-df text-333">{{item.certificate_name}}</p>
						<p class="text-df text-ccc margin-left-xs">{{item.time}} 获得</p>
					</div>
					<div class="flex align-center pointer" @click="editcer(item)">
						<img src="../../assets/img/edit_p.png" >
						<p class="text-xs text-333 margin-left-xs">修改</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Bus from '@/store/eventBus.js'
	export default {
		data() {
			return {
				user:null,//
				userInfo:null,//
				certificate:[],//技能证书
				experience:[],//工作经历
				seeUserinfo:0,//被查看次数
			}
		},
		created() {
			this.getinfo()
			Bus.$on('addok',()=>{
				this.getinfo()
			})
		},
		destroyed() {
			Bus.$off('addok')
		},
		methods: {
			getinfo(){
				this.ajax('get', '/api/pc/userInfo/myUserInfo',{}, res => {
					if (res.status == 200) {
						this.user = res.data.user
						this.userInfo = res.data.userInfo.length == 0?null:res.data.userInfo
						this.certificate = res.data.certificate
						this.experience = res.data.experience
						this.seeUserinfo = res.data.seeUserinfo
					} else {
						this.$message(res.msg);
					}
				})
			},
			golink(){
				
			},
			//通知center 跳转对应页面
			godetail(index,typeone){
				let one = typeone?typeone:''
				let type = {
					type:index,
					typeone:one
				}
				this.$emit('gettype',type)
			},
			//项目经历
			addpro(){
				this.$emit('addpro')
			},
			//技能证书
			addcerti(){
				console.log('----');
				this.$emit('addcer')
			},
			//编辑经历
			editpro(item){
				this.$emit('addpro')
				setTimeout(()=>{
					Bus.$emit('editpro',item)
				},500)
			},
			//编辑证书
			editcer(item){
				this.$emit('addcer')
				setTimeout(()=>{
					Bus.$emit('editcer',item)
				},500)
			}
		},
		filters:{
			filterType(val) {
			  switch (val) {
				case 0:
				  	return '个人';
			  	case 1:
			  		return '班组';
			  	case 2:
			  		return '施工队';
			  	case 3:
			  		return '突击队';
			  
			  	default:
			  		return '';
			  }
			}
		}
	}
</script>

<style scoped lang="less">
	.name{
		font-size: 22px;
	}
	.myinfo{
		width: 597px;
		height: 188px;
		box-shadow: -4px 3px 19px 1px rgba(204,204,204,0.2000);
		border-radius: 20px;
		.block-74{
			width: 74px;
			height: 74px;
			border-radius: 50%;
		}
		
		.identity{
			width: 54px;
			height: 22px;
			background: rgba(11,131,124,0.1);
			border-radius: 6px;
		}
		.realname{
			height: 43px;
			background: rgba(11,131,124,0.1000);
			box-shadow: 0px 4px 19px 0px rgba(208,208,208,0.0500);
			border-radius: 0px 0px 20px 20px;
			padding: 10px 21px;
		}
	}
	.basic{
		width: 922px;
		border-radius: 20px;
		box-shadow: 0px 4px 19px 0px rgba(208,208,208,0.0500);
	}
	.czuo{
		width: 26px;
		height: 22px;
	}
	.titlan{
		width: 92px;
	}
	.block-90{
		width: 90px;
		height: 90px;
	}
	.block-103{
		width: 103px;
		height: 103px;
	}
</style>



// WEBPACK FOOTER //
// src/view/my/resume.vue